'use client';

// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled, useTheme, alpha } from '@mui/material/styles';
// _mock
import { _pricingPlans } from 'src/_mock';
//
import PricingCard from './pricing-card';
import { useState } from 'react';

// ----------------------------------------------------------------------

// Custom styled switch for a more modern look
const ModernSwitch = styled(Switch)(({ theme }) => {
  const isLight = theme.palette.mode === 'light';
  return {
    width: 56,
    height: 28,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(28px)',
        color: isLight ? '#ffffff' : theme.palette.grey[900],
        '& + .MuiSwitch-track': {
          backgroundColor: isLight ? theme.palette.grey[900] : '#ffffff',
          opacity: 1,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 24,
      height: 24,
      backgroundColor: isLight ? theme.palette.grey[900] : '#ffffff',
    },
    '& .MuiSwitch-track': {
      borderRadius: 14,
      backgroundColor: alpha(theme.palette.text.primary, 0.2),
      opacity: 1,
    },
  };
});

export default function PricingView() {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  const [monthly, setMonthly] = useState(true);

  return (
    <Container
      sx={{
        pt: 0,
        pb: 10,
        minHeight: 1,
      }}
      id="pricing"
    >
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography
          variant="overline"
          sx={{
            color: '#FF6D00', // Tactical Orange
            letterSpacing: '0.1em',
            fontSize: '0.75rem',
            mb: 2,
            display: 'block',
          }}
        >
          // ACCESS TIERS
        </Typography>
        <Typography
          variant="h2"
          sx={{
            mb: 2,
            color: 'text.primary',
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.5rem' },
          }}
        >
          Choose Your Plan
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'text.secondary', maxWidth: '500px', mx: 'auto' }}
        >
          Unlock exclusive insights with a plan that suits your needs
        </Typography>
      </Box>

      {/* Toggle */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{
            background: '#0A0A0A',
            border: `1px solid #151515`,
            borderRadius: '24px',
            px: 3,
            py: 1.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: monthly ? '#fff' : '#888',
              fontWeight: monthly ? 600 : 400,
              transition: 'all 0.2s ease',
            }}
          >
            Monthly
          </Typography>
          <ModernSwitch
            checked={!monthly}
            onChange={() => setMonthly(!monthly)}
          />
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography
              variant="body2"
              sx={{
                color: !monthly ? 'text.primary' : 'text.secondary',
                fontWeight: !monthly ? 600 : 400,
                transition: 'all 0.2s ease',
              }}
            >
              Yearly
            </Typography>
            <Box
              sx={{
                background: isLight ? theme.palette.grey[900] : '#ffffff',
                color: isLight ? '#ffffff' : theme.palette.grey[900],
                fontSize: '0.7rem',
                fontWeight: 700,
                px: 1,
                py: 0.25,
                borderRadius: '4px',
              }}
            >
              SAVE 20%
            </Box>
          </Stack>
        </Stack>
      </Box>

      {/* Pricing Cards */}
      <Box
        gap={3}
        display="grid"
        alignItems="stretch"
        gridTemplateColumns={{
          xs: '1fr',
          md: monthly ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)',
        }}
      >
        {_pricingPlans
          .filter(card => card.yearlyPrice !== 0 || monthly)
          .map((card, index) => (
            <PricingCard key={card.subscription} card={card} index={index} monthly={monthly} />
        ))}
      </Box>
    </Container>
  );
}
